<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading && items.length" class="position-relative slides">
        <v-container class="py-0">
          <hooper-container
            class="slides-container"
            style="height: auto"
            ref="carousel"
            :autoPlay="true"
            :playSpeed="6000"
            :wheelControl="false"
            :mouseDrag="items.length > 1"
            :touchDrag="items.length > 1"
            :infiniteScroll="items.length > 1"
          >
            <hooper-slide
              class="py-14 item"
              v-for="({ img_logo, img_bg, title }, keySlide) in items"
              :key="keySlide"
            >
              <v-row
                class="my-0"
                justify="center"
                :justify-md="img_bg ? 'start' : 'center'"
              >
                <v-col v-if="!smAndDown && img_bg" md="8" order="12">
                  <img class="d-block item-bg" :src="files + img_bg" />
                </v-col>

                <v-col class="position-relative" cols="10" md="4" order="0">
                  <div class="d-flex align-center flex-column">
                    <img
                      v-if="img_logo"
                      class="d-block"
                      :src="files + img_logo"
                      width="85%"
                    />

                    <div
                      v-if="title"
                      class="white--text text-h6 text-center font-weight-bold"
                      :class="{ 'mt-7': img_logo }"
                    >
                      {{ title }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </hooper-slide>
          </hooper-container>
        </v-container>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

const _config = {
  mod: "awards",
};

export default {
  data: () => ({
    loading: true,
    carouselData: 0,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>

<style lang="scss" scoped>
.slides-container::v-deep {
  ul,
  ol {
    padding: 0 !important;
  }
}

.slides {
  background: rgb(45, 45, 45);
  background: -moz-linear-gradient(
    0deg,
    rgba(45, 45, 45, 1) 0%,
    rgba(8, 8, 8, 1) 60%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(45, 45, 45, 1) 0%,
    rgba(8, 8, 8, 1) 60%
  );
  background: linear-gradient(
    0deg,
    rgba(45, 45, 45, 1) 0%,
    rgba(8, 8, 8, 1) 60%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2d2d2d",endColorstr="#080808",GradientType=1);

  .item {
    &-bg {
      height: 100%;
      -o-object-fit: contain;
      object-fit: contain;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
